import { useState } from 'preact/hooks';
import { get, post } from '../api';
import { me } from '../session';
import { Button, Card, Field, navigate, toast, useAction, useLoad } from '../ui';

export function CreateGame() {
	const m = me.use();
	const lib = useLoad(() => get('/api/templates/mine'));
	const [source, setSource] = useState('sample');
	const [name, setName] = useState('');
	const [listing, setListing] = useState<'public' | 'unlisted'>('public');
	const [password, setPassword] = useState('');
	const [approval, setApproval] = useState(false);
	const [seats, setSeats] = useState(4);
	const [timer, setTimer] = useState(60);
	const [tags, setTags] = useState('');
	const [description, setDescription] = useState('');
	const maxPlayers = m?.plan?.def?.maxPlayers ?? 4;
	const library = (lib.data?.library ?? []) as any[];
	const [create, busy] = useAction(async () => {
		const src = source === 'sample' ? { sample: 'sunken_crypt' } : { templateId: source };
		const r = await post('/api/games', {
			name: name || undefined,
			source: src,
			listing,
			password: password || undefined,
			approval,
			seats,
			timerSeconds: timer,
			tags: tags
				.split(',')
				.map((t) => t.trim().toLowerCase())
				.filter(Boolean),
			description: description || undefined,
		});
		toast(`Game created: ${r.displayCode}`, 'ok');
		navigate(`/g/${r.code}`);
	});
	return (
		<main class="page narrow">
			<h1>Create a game</h1>
			<Card title="1. World">
				<Field label="Start from">
					<select value={source} onChange={(e) => setSource(e.currentTarget.value)}>
						<option value="sample">The Sunken Crypt (sample dungeon)</option>
						{library.length ? (
							<optgroup label="Your template library">
								{library.map((l: any) => (
									<option key={l.templateId} value={l.templateId}>
										{l.title} (v{l.version})
									</option>
								))}
							</optgroup>
						) : null}
					</select>
				</Field>
				<p class="small muted">
					Need something else? Pick one from <a href="/templates">templates</a>.
				</p>
			</Card>
			<Card title="2. Table">
				<Field label="Game name">
					<input value={name} onInput={(e) => setName(e.currentTarget.value)} placeholder="Defaults to the story title" maxLength={80} />
				</Field>
				<Field label="Description">
					<textarea value={description} onInput={(e) => setDescription(e.currentTarget.value)} rows={2} maxLength={600} placeholder="Shown in the game browser" />
				</Field>
				<div class="row">
					<Field label={`Seats (1–${maxPlayers})`}>
						<input type="number" min={1} max={maxPlayers} value={seats} onInput={(e) => setSeats(Number(e.currentTarget.value))} />
					</Field>
					<Field label="Action timer (seconds)">
						<input type="number" min={10} max={600} value={timer} onInput={(e) => setTimer(Number(e.currentTarget.value))} />
					</Field>
				</div>
				<Field label="Tags" hint="Comma separated, e.g. horror, beginner">
					<input value={tags} onInput={(e) => setTags(e.currentTarget.value)} />
				</Field>
			</Card>
			<Card title="3. Access">
				<div class="row">
					<Field label="Listing">
						<select value={listing} onChange={(e) => setListing(e.currentTarget.value as any)}>
							<option value="public">Public in the browser</option>
							<option value="unlisted">Unlisted (code only)</option>
						</select>
					</Field>
					<Field label="Password (optional)">
						<input type="password" value={password} onInput={(e) => setPassword(e.currentTarget.value)} autocomplete="new-password" />
					</Field>
				</div>
				<label class="check">
					<input type="checkbox" checked={approval} onChange={(e) => setApproval(e.currentTarget.checked)} /> I approve each join
				</label>
				<p class="small muted">You'll set up the language models (your own key, a local model, or included models) from the Game Master tab once the game exists.</p>
			</Card>
			<div class="row-end">
				<Button onClick={() => create()} busy={busy}>
					Create game
				</Button>
			</div>
		</main>
	);
}
